import { render, staticRenderFns } from "./RateModal.vue?vue&type=template&id=6a64033d&scoped=true&"
import script from "./RateModal.vue?vue&type=script&lang=js&"
export * from "./RateModal.vue?vue&type=script&lang=js&"
import style0 from "./RateModal.vue?vue&type=style&index=0&id=6a64033d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64033d",
  null
  
)

export default component.exports